// Pot Round action types
export const CREATE_POT_ROUND = "CREATE_POT_ROUND";
export const PUBLISH_POT_ROUND = "PUBLISH_POT_ROUND";
export const FETCH_POT_ROUNDS = "FETCH_POT_ROUNDS";

// Pot Fixture action types
export const CREATE_POT_FIXTURE = "CREATE_POT_FIXTURE";
export const FETCH_POT_FIXTURES = "FETCH_POT_FIXTURES";

// Pot action types
export const CREATE_POT = "CREATE_POT";
export const FETCH_POTS = "FETCH_POTS";

// Pot Entries action types
export const FETCH_POT_ENTRIES = "FETCH_POT_ENTRIES";

// Pot Payments action types
export const FETCH_POT_PAYMENTS = "FETCH_POT_PAYMENTS";

// Pot Rollover Credits action types
export const CREATE_POT_ROLLOVER_CREDIT = "CREATE_POT_ROLLOVER_CREDIT";
export const FETCH_POT_ROLLOVER_CREDITS = "FETCH_POT_ROLLOVER_CREDITS";

// Supported League Fixtures action types
export const FETCH_SUPPORTED_LEAGUE_FIXTURES = "FETCH_SUPPORTED_LEAGUE_FIXTURES";
